var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-5 py-16"},[_c('v-container',{staticClass:"justify-center",attrs:{"fill-height":""}},[_c('nuxt')],1)],1),_vm._v(" "),_c('Snackbar'),_vm._v(" "),_c('TheDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }